module.exports = __webpack_public_path__ + "img/logo-treineemcasa.090609ea.png";